import { put, call } from 'redux-saga/effects';
import { casesForExcelApi } from 'src/api/CaseApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { EXCEL_CASE_ACTIONS } from '../actions/ExcelActions';

function* search({
    where,
    sortBy = 'ts',
    sortOrder = -1,
    autopopulate = true,
    fullTextSearch = true,
} = {}) {
  
    try {
        const {
            data: { data },
        } = yield call(casesForExcelApi, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            sortBy,
            sortOrder,
            autopopulate,
        });
     
        yield put({
            type: EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH_ERROR,
        });
        return null;
    }
}



export default [
    takeFirstSagaUtil(EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH, search),
];
